export default __webpack_public_path__ + "static/media/BLUE_PINK_GOLD.96215abd.jpg";